import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError, handlePrompt, handleSimpleMessage, handleAlertBoxClick } from "../../Common/Layout/CustomAlerts";
import moment from "moment";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
import { Link, useParams } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
const cardElementOptions = {
    style: {
        base: {
            fontSize: "16px",
            color: "#424770",
            "::placeholder": { color: "#aab7c4" },
            backgroundColor: "#fff",    
            padding: "10px",
            border:"1px solid black"
        },
        invalid: { color: "#9e2146" }
    }
};
export default function UserCredits() {
    const params = useParams();
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [loadingPayment, setLoadingPayment] = useState(false);
    const [clientData, setClientData] = useState({});
    const [showCard, setShowCard] = useState(false);
    const [clientSecret, setClientSecret] = useState("");
    const [inputValues, setInputValues] = useState({});
    const [creditPricing, setCreditPricing] = useState([]);
    const [creditTransactions, setCreditTransactions] = useState([]);
    const [credits, setCredits] = useState(0);
    const [amount, setAmount] = useState(0);
    const [errors, setErrors] = useState({});
    const [lists, setLists] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [refreshKey, setRefreshKey] = useState(0);
    const GetUserCredits = () => {
        axios.get(config.APIACTIVATEURL + config.GETUSERCREDITTRANSACTIONS + "/" + localStorage.getItem("userId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setCreditTransactions(response.data.data);
                }
                else {
                    setCreditTransactions([]);
                }
            });
    }
    const GetCreditsPricing = () => {
        axios.get(config.APIACTIVATEURL + config.GETCREDITPRICING, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setCreditPricing(response.data.data.data);
                }
            });
    }
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const validate = () => {
        let temp = {};
        temp.amount = amount === 0 ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAmount(value);
        setCredits(getCreditsByUSD(amount));
    };
    const getCreditsByUSD = (amount) => {
        const pricing = creditPricing.find(item => item.totalUSD === parseInt(amount));
        return pricing ? pricing.totalCredits : 0; // Return 0 if not found
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (clientData.type !== "TRAIL") {
            if (validate()) {
                setLoading(true);
                var formData = {
                    "clientId": localStorage.getItem('clientId'),
                    "userId": localStorage.getItem('userId'),
                    "credits": getCreditsByUSD(amount),
                    "type": "CREDITED",
                    "transactionDate": moment(new Date()).format('YYYY-MM-DD'),
                    "status": "SUCCESS",
                    "amount": amount,
                    "comment": "Amount paid for credits"
                }
                setInputValues(formData);
                GetPaymentKey(formData);
            }
        } else {
            handleAlertBoxClick("Please upgrade account to buy credits");
        }
    };
    const GetPaymentKey = (formData) => {
        axios.post(config.APIACTIVATEURL + config.CREATEPAYMENTTRANSACTION + "?Amount=" + parseFloat(formData.amount) * 100, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setClientSecret(response.data.data);
                    setShowCard(true);
                }
                else {
                    setLoading(false);
                }
            });
    };
    const handlePayment = (e) => {
        MakePayment(e);
    }
    const MakePayment = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        const cardElement = elements.getElement(CardElement);
        if (!cardElement) {
            console.error("CardElement is not found.");
            return;
        }
        setLoading(true);
        setLoadingPayment(true);
        const result = await stripe.confirmCardPayment(clientSecret, {
            payment_method: { card: cardElement }
        });
        if (result.error) {
            handleError(result.error.message);
        } else {
            InsertTransaction();
        }
    }
    const InsertTransaction = () => {
        console.log(inputValues);
        axios.post(config.APIACTIVATEURL + config.CREATECREDITTRANSACTION, inputValues, { ...headerconfig })
            .then((response) => {
                console.log(response);
                if (response.data.statusCode === 200) {
                    GetClientData();
                    GetUserCredits();
                    GetData();
                    setRefreshKey((prevKey) => prevKey + 1); // Triggers re-render
                    handleSuccess("Credits Updated Successfully");
                    setShowCard(false);
                    setLoading(false);
                    setLoadingPayment(false);
                }
            });
    };
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETUSERCREDITTRANSACTIONS + "/" + localStorage.getItem('clientId'), { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLists(response.data.data.data);
                    setPageNumber(response.data.data.pageNumber);
                    setPageSize(response.data.data.pageSize);
                    setTotalPages(response.data.data.totalPages);
                    setData(response.data.data);
                    setTotalRecords(response.data.data.totalRecords);
                }
            });
    };
    const GetClientData = () => {
        axios.get(config.APIACTIVATEURL + config.GETCLIENTBYID + "/" + localStorage.getItem("clientId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setClientData(response.data.data);
                }
                else {
                    setClientData({});
                }
            });
    }
    const GetLastPageData = () => {
        GetData(totalPages)
    }
    const GetFirstPageData = () => {
        GetData("1")
    }
    const GetPageData = (number) => {
        setPageNumber(number);
        if (pageNumber !== number)
            GetData(number)
    }
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map((number) => {
        return (
            <li className="page-item" key={number} id={number} onClick={() => GetPageData(number)}>
                <Link className="page-link">{number}</Link>
            </li>
        );
    });
    const resetForm = () => {
        setCredits(0);
        setAmount(0);
    };
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        if (localStorage.getItem('userId') !== null) {
            GetUserCredits();
            GetCreditsPricing();
            GetClientData();
            GetData();
        }
    }, [])
    return (
        <div id="layout-wrapper">
            <Header key={refreshKey}></Header>
            <SideBar></SideBar>
                <div className="body-wrapper">
                    <div className="card">                    
                    {showCard ? (
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="card">
                                    <div className="card-header"><h5>Please enter card details</h5></div>
                                    <div className="card-body">
                                        <div className="border border-gray-300 rounded-md p-3">
                                            <CardElement options={cardElementOptions} />
                                        </div>
                                        {loadingPayment === false ?
                                            <button onClick={handlePayment} className="w-full btn btn-primary mt-4">Proceed to Payment</button>
                                            :
                                            <button disabled className="w-full btn btn-primary mt-4">Processing...</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) :
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form onSubmit={(e) => handleSubmit(e)} autoComplete="off" noValidate>
                                            <div className="row">
                                                <div className="col-lg-4 mb-3">
                                                    <h5>Available Credits : {clientData.availableCredits}</h5>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4 mb-3">
                                                    <label htmlFor="amount" className="form-label">Select Amount to Buy</label>
                                                    <select className="form-select" name="amount" value={amount} onChange={handleInputChange}>
                                                        <option value={0}>Please select credits</option>
                                                        {creditPricing.length > 0 && creditPricing.map(cp =>
                                                            <option value={cp.totalUSD}>{cp.totalCredits} Credits for {cp.totalUSD} USD</option>
                                                        )}
                                                    </select>
                                                    {errors.amount === false ? (<div className="validationerror">Please select credits</div>) : ('')}
                                                </div>
                                                <div className="col-lg-8 mt-4">
                                                    <div className="hstack gap-2 justify-content-start">
                                                        {loading === false ?
                                                            <button type="submit" className="btn btn-info">Buy Credits</button>
                                                            :
                                                            <button type="button" className="btn btn-info" disabled>Loading, Please wait...</button>}
                                                        <button type="button" className="btn btn-danger" onClick={resetForm}>Cancel</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
</div>
                    <div className="card">
                        <div className="card-header">
                            <h5>Credits Information</h5>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive table-card">
                                <table className="table align-middle" id="customerTable">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Credits</th>
                                            <th>Type</th>
                                            <th>Status</th>
                                            <th>Transaction Date</th>
                                            <th>Comment</th>
                                        </tr>
                                    </thead>
                                    <tbody className="list form-check-all">
                                        {lists.length > 0 && lists.map((v, index) =>
                                            <tr key={v.creditTransactionId}>
                                                <td>{index + 1}</td>
                                                <td>{v.credits} Credits</td>
                                                <td>{v.type === "CREDITED" ? <span class="badge text-bg-success">CREDITED</span> : <span class="badge text-bg-primary">DEBITED</span>}</td>
                                                <td>{v.status === "SUCCESS" ? <span class="badge text-bg-success">SUCCESS</span> : <span class="badge text-bg-primary">{v.status}</span>}</td>
                                                <td>{moment.utc(v.transactionDate).local().format('DD MMM YYYY HH:mm')}</td>
                                                <td>{v.comment}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                <div className="flex-shrink-0">
                                    <div className="text-muted">
                                        Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                    </div>
                                </div>
                                <ul className="pagination pagination-separated pagination-sm mb-0">
                                    <li className={"page-item" + data.previousPage === null ? 'disabled' : ''} onClick={() => GetFirstPageData()}>
                                        <Link className="page-link">Previous</Link>
                                    </li>
                                    {renderPageNumbers}
                                    <li className={"page-item" + data.nextPage === null ? 'disabled' : ''} onClick={() => GetLastPageData()}>
                                        <Link className="page-link">Next</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}